import React from 'react';
import Header from '../../../components/common/Header/header';
import { Link } from 'react-router-dom';
import video_presentation from '../../../assets/video/video-presentation.webm';

import './About.css';

function About() {
    return (
        <div className="about-container">
            <div className="about-header">
                <Header />
            </div>

            <main className="about-content">
                <div className="about-two-panel">
                    <section className="about-video-panel" aria-label="Vidéo de présentation">
                        <video
                            className="about-video"
                            autoPlay
                            loop
                            muted
                            playsInline
                            preload="metadata"
                            controls
                        >
                            <source src={video_presentation} type="video/webm" />
                            Votre navigateur ne supporte pas la lecture vidéo.
                        </video>
                    </section>

                    <section className="about-text-panel">
                        <h1 className="about-title">À propos</h1>
                        <div className="about-text">
                            <p>
                                Chez chaque vêtement est une rencontre.
                                Une rencontre entre l’élégance naturelle, le respect de la personne, et l’amour du fait main.
                            </p>

                            <p>
                                Je ne fais pas que coudre des tissus.
                                Je crée des pièces qui racontent une histoire.
                                Celle de l’artisan qui les façonne, mais surtout celle de la personne qui les porte.
                            </p>

                            <p>
                                Fondée en mars 2025 par le jeune artisan couturier Jérémy Delisle, la marque est née d’un désir simple :
                                Créer des vêtements qui ont du sens.
                            </p>

                            <div className="about-mission">
                                <div className="about-mission-title">Ma mission :</div>
                                <ul>
                                    <li>Créer des vêtements respectueux de l’environnement et de ceux qui les portent</li>
                                    <li>Fabriquer chaque pièce à la main, avec soin, dans une démarche artisanale</li>
                                    <li>Proposer des pièces élégantes, confortables, et profondément humaines</li>
                                    <li>Raconter des histoires à travers chaque couture, chaque étoffe</li>
                                </ul>
                            </div>

                            <p>
                                Je crois que le vêtement est une langue vivante.
                                Qu’il peut être le prolongement de qui nous sommes.
                            </p>

                            <p>
                                Mon rêve ?
                                Que devienne une référence mondiale du vêtement artisanal, élégant et éthique.
                                Une maison qui célèbre l’être, pas l’image.
                                Un vêtement pour être soi.
                            </p>
                        </div>
                    </section>
                </div>
            </main>
            <footer className="about-footer">
                <Link to="/legal-mention">Mentions légales</Link>
            </footer>
        </div>
    );
}

export default About;